// extracted by mini-css-extract-plugin
export default {"content":"SVfNeo","buttons":"zcmkQ0","title":"emNH7z","text":"vBlh5k","publisher":"YuO1NO","overlay":"MCQmsR"};